/** Display helpers. All times shown in UK local time. */
import { localDate, localTime, zonedToUtc } from "../../shared/time";

const tz = "Europe/London";

export const fmtTime = (ms: number) =>
  new Intl.DateTimeFormat("en-GB", { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(ms);

export const fmtDate = (ms: number) =>
  new Intl.DateTimeFormat("en-GB", { timeZone: tz, weekday: "short", day: "numeric", month: "short" }).format(
    ms,
  );

export const fmtDateTime = (ms: number) => `${fmtDate(ms)}, ${fmtTime(ms)}`;

export function fmtDuration(minutes: number | null): string {
  if (minutes == null) return "—";
  const m = Math.round(minutes);
  const h = Math.floor(m / 60);
  return h ? `${h}h ${String(m % 60).padStart(2, "0")}m` : `${m}m`;
}

export const fmtDistance = (m: number | null) =>
  m == null ? "—" : m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(1)} km`;

/** YYYY-MM-DD for a UK local date. */
export function isoLocalDate(ms: number = Date.now()): string {
  const p = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  return p.format(ms);
}

export function addDaysIso(date: string, days: number): string {
  const [y, m, d] = date.split("-").map(Number) as [number, number, number];
  const t = new Date(Date.UTC(y, m - 1, d + days));
  return t.toISOString().slice(0, 10);
}

/** Value for <input type="datetime-local"> in UK time, from epoch ms. */
export function toLocalInput(ms: number): string {
  return `${localDate(ms)}T${localTime(ms)}`;
}

/**
 * Epoch ms from a datetime-local value interpreted as UK time. Uses the same rules as the
 * server (shared/time.zonedToUtc): a time that happens twice when the clocks go back is the
 * first (BST) one, and a time skipped when they go forward moves forward by the hour.
 * Seconds, if the browser adds them, are ignored.
 */
export function fromLocalInput(value: string): number {
  const [date = "", time = "00:00"] = value.split("T");
  return zonedToUtc(date, time.slice(0, 5));
}
